import { Dispatch, FC, Fragment, useEffect, useState } from "react";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
} from "@mui/material";
import { useStyles } from "../styles";
import { LoadingButton } from "@mui/lab";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { AlertType } from "../../../types/AlertType";
import { AxiosInstance } from "axios";
import CheckAttr from "../../../utils/CheckAttr";
import { AllMounth, yearsToDisplay } from "../../../constants/Constants";
import { PrevisionnelInterface } from "../../content/previsionnel/quantite/PrevisionnelQuantiteInterface";

interface UpdatePrevisionnelQtProps {
  onClose: () => void;
  previsionnel: PrevisionnelInterface;
  http: AxiosInstance;
  setOpenSnack: Dispatch<React.SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<React.SetStateAction<string>>;
  setAlertType: Dispatch<React.SetStateAction<AlertType>>;
  reloadList: () => void;
}

const UpdatePrevisionnelQt: FC<UpdatePrevisionnelQtProps> = ({
  onClose,
  previsionnel,
  http,
  setOpenSnack,
  setAlerteMessage,
  setAlertType,
  reloadList,
}) => {
  const classes = useStyles();
  const [mounthSelected, setMounthSelected] = useState<Number>(
    previsionnel?.mois
  );
  const [yearSelected, setYearSelected] = useState<Number>(previsionnel?.annee);

  const [prevActe, setprevActe] = useState<Number>(previsionnel?.acte_prev);
  const [prevHeure, setPrevHeure] = useState<Number>(previsionnel?.heure_prev);
  const [isClickSave, setIsClickSave] = useState<boolean>(false);

  const handleUpdate = () => {
    const dataToUpdate = {
      id: previsionnel?.id,
      mois: mounthSelected,
      annee: yearSelected,
      prevActe: prevActe,
      prevHeure: prevHeure,
      article_id: previsionnel?.article_id,
    };

    console.log(dataToUpdate);
    setIsClickSave(true);
    http
      .post(`forecast/update`, dataToUpdate)
      .then((res) => {
        if (typeof res.data === "string") {
            setAlerteMessage(res.data);
            setAlertType("warning");
            setOpenSnack(true);
        }
        else{
            setAlerteMessage("Enregistrement efféctuée !");
            setAlertType("success");
            setOpenSnack(true);
            reloadList();
            onClose();
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsClickSave(false);
      });
  };
  const disableActeInput = (): boolean => {
    if (CheckAttr(prevHeure) && prevHeure !== 0) {
      return true;
    }

    return false;
  };

  const disableHeureInput = (): boolean => {
    if (CheckAttr(prevActe) && prevActe !== 0) {
      return true;
    }

    return false;
  };
  return (
    <Fragment>
      <Box className={classes.root}>
        <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
          <Grid item xs={6} sm={6} md={2}>
            <TextField
              label="Pays de production"
              color="warning"
              fullWidth
              //error={errorInput.pays}
              value={previsionnel?.pays_libelle}
              //onChange={handleChange}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="Client"
              color="warning"
              fullWidth
              //error={errorInput.client}
              value={previsionnel?.client_libelle}
              // onChange={handleChange}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="Operation"
              color="warning"
              fullWidth
              //error={errorInput.operation}
              value={previsionnel?.operation_libelle}
              //onChange={handleChange}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="Désignation / Article"
              color="warning"
              fullWidth
              //error={errorInput.article}
              value={previsionnel?.article_libelle}
              // onChange={handleChange}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
            />

            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="year"
                color="warning"
                shrink={CheckAttr(yearSelected)}
              >
                Année
              </InputLabel>
              <Select
                id="year"
                native
                color="warning"
                value={yearSelected}
                onChange={(e: any) => {
                  setYearSelected(e.target.value as Number);
                }}
                // error={errorInput.year}
                label="Année"
                inputProps={{
                  name: "year",
                }}
              >
                <option value={0}></option>
                {yearsToDisplay.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6} md={2}>
            <FormControl
              variant="outlined"
              className={classes.formControl}
              sx={{ marginLeft: 1, marginTop: 1 }}
            >
              <InputLabel
                htmlFor="month"
                color="warning"
                shrink={CheckAttr(mounthSelected)}
              >
                Mois
              </InputLabel>
              <Select
                id="month"
                native
                color="warning"
                value={mounthSelected}
                // onChange={handleChange}
                //error={errorInput.month}
                label="Mois"
                inputProps={{
                  name: "month",
                }}
                onChange={(e: any) => {
                  setMounthSelected(e.target.value as Number);
                }}
              >
                <option value=""></option>
                {AllMounth.map((month) => (
                  <option key={month?.id} value={month?.id}>
                    {month?.mounth}
                  </option>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Forecast Actes"
              color="warning"
              fullWidth
              //error={errorInput.ca_budget}
              disabled={disableActeInput()}
              name="ca_budget"
              value={prevActe}
              onChange={(e: any) => {
                setprevActe(e.target.value as Number);
              }}
              //onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="Forecast Heure"
              color="warning"
              fullWidth
              // error={errorInput.tx_marge_budget}
              name="tx_marge_budget"
              value={prevHeure}
              onChange={(e: any) => {
                setPrevHeure(e.target.value as Number);
              }}
              disabled={disableHeureInput()}
              // onChange={handleChange}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center" mt={5}>
          <LoadingButton
            onClick={() => handleUpdate()}
            endIcon={<BorderColorIcon />}
            loading={isClickSave}
            loadingPosition="end"
            sx={{ textTransform: "none" }}
            variant="contained"
            color="warning"
          >
            Enregistrer
          </LoadingButton>
        </Box>
      </Box>
    </Fragment>
  );
};

export default UpdatePrevisionnelQt;
